"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerIcon = void 0;
const react_1 = __importDefault(require("react"));
const SpinnerIcon = ({ iconSize = '36' }) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: iconSize, height: iconSize, display: "block", preserveAspectRatio: "xMidYMid", viewBox: "0 0 100 100", style: { background: 'none' } },
    react_1.default.createElement("circle", { cx: "50", cy: "50", r: "38", fill: "none", stroke: "#5144c2", strokeDasharray: "179.0707812546182 61.690260418206066", strokeWidth: "10", transform: "rotate(191.748 50 50)" },
        react_1.default.createElement("animateTransform", { attributeName: "transform", dur: "1s", keyTimes: "0;1", repeatCount: "indefinite", type: "rotate", values: "0 50 50;360 50 50" }))));
exports.SpinnerIcon = SpinnerIcon;
